import { MAX_FILES_PER_SELECTION } from '@flowshare/protocol';
import { create } from 'zustand';

interface PendingFilesStore {
  files: File[];
  add: (files: File[]) => void;
  remove: (index: number) => void;
  clear: () => void;
}

export const usePendingFilesStore = create<PendingFilesStore>()((set) => ({
  files: [],
  add: (files) =>
    set((state) => {
      const merged = [...state.files];
      for (const file of files) {
        if (merged.length >= MAX_FILES_PER_SELECTION) break;
        if (!merged.some((existing) => sameFile(existing, file))) merged.push(file);
      }
      return { files: merged };
    }),
  remove: (index) =>
    set((state) => ({ files: state.files.filter((_, current) => current !== index) })),
  clear: () => set({ files: [] }),
}));

function sameFile(left: File, right: File): boolean {
  return (
    left.name === right.name &&
    left.size === right.size &&
    left.lastModified === right.lastModified &&
    left.type === right.type
  );
}
